import '../styles/Footer.css';
import '../styles/theme-variables.css';

function Footer() {
    return (
        <footer className="footer">
            <p>© 2026 RL Performance Calculator</p>
        </footer>
    );
}

export default Footer;